import FSVideoEmbed from "../../components/platformPlayer/FsVideoEmbed";


// WEBPACK FOOTER //
// ./assets/layouts/video/fs-video-embed.js